// extracted by mini-css-extract-plugin
module.exports = {"videoPlayerContainer":"videoPlayerContainer__3T4p2","videoTrailer":"videoTrailer__1780M","fullscreen":"fullscreen__1DCd3","videoContainer":"videoContainer__2wPLb"};